module.exports = __webpack_public_path__ + "media/images/mobile/solutions/7-4548cd7fa668578304cb746359b7550e.png";